import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { callHangUp, dialerTokenRequest, getDialerSettings, sendErrorMessageToDevelopers, callCancelByCallSid, callCompleteByCallSid } from "../../../api/globalDialerApi";
import Stage from "./Stage";
import CallingState from "./CallingState";
import NumberPad from "./NumberPad";
import './global-dialer.css';
import {
    toggleScreen,
    updateSecondCallStatus,
    selectActiveContact,
    getCurrentCredit,
    resetDialerWithNumber,
    resetDialer,
    storeMultipleReducers,
    getVirtualNumbers
} from "../../../actions/globalDialerAction";
import { _updateContactId } from '../../contactDetails/redux/contactDetailAction'
import RecentContacts from "./RecentContacts";
import FromNumber from "./FromNumber";
import DialTrigger from "./DialTrigger";
import { Device } from '@twilio/voice-sdk';
import Utils from "../../../helpers/Utils";
import SecondCall from "./SecondCall";
import Helper from "../../DirectCardSend/assets/Helper";
import CallEnvironmentSetupAlertPop from "../../CallEnvironmentSetupAlertPop/CallEnvironmentSetupAlertPop";
import { callEnvironment } from "../../../api/contactApi";

let device;
let callEvent;

const GlobalDialer = props => {

    const userId = Utils.getAccountData('userId');

    const [callOnScreen, setCallOnScreen] = useState(props.callOnScreen);
    const [activeCallConnection, setActiveCallConnection] = useState(null);
    const [callingTab, setCallingTab] = useState(false);
    const [resetDialerClearTimeout, setResetDialerClearTimeout] = useState(null)
    const [maximumTryToGetToken, setMaximumTryToGetToken] = useState(0);
    const [showCallEnvSetupAlertPopup, setShowCallEnvSetupAlertPopup] = useState(false);
    const [callEnvSetupAlertPopupData, setCallEnvSetupAlertPopupData] = useState(null);
    const isCallInProgressRef = useRef(false);

    // Update the ref when the call state changes
    useEffect(() => {
        isCallInProgressRef.current = { callStatus: props.isCallInProgress, callSid: props.callInfo?.callSid }
    }, [props.isCallInProgress]);

    useEffect(() => {

        if (props.globalDialerSocket) {
            props.globalDialerSocket.emit('join-call-room', 'callRoom:' + userId);

            props.globalDialerSocket.on('participant-join', data => {
                if (data.room === 'callRoom:' + userId) {
                    console.log(data);
                    if (data.params.participant === 'participant1') {
                        props.storeMultipleReducers({ callStatus: 'Received' });
                    }
                    if (data.params.participant === 'participant2') {
                        props.updateSecondCallStatus('Received');
                    }
                }
            });

            props.globalDialerSocket.on('call-started', data => {
                if (data.room === 'callRoom:' + userId) {
                    let callerName = ''
                    if (!Utils.isEmpty(data.params.callerName)) {
                        callerName = data.params.callerName
                        callerName = callerName.replace('-_-20', ' ')
                    } else {

                        callerName = data.params.To
                    }

                    props.storeMultipleReducers({
                        ...props.callInfo, ...{
                            conferenceSid: data.params.conferenceSid,
                            firstCallSid: data.params.callSid,
                            callerName: callerName
                        }, callStatus: "Received"
                    })

                    device.emit('connect', {
                        callSid: data.params.callSid,
                        token: device.token,
                        callerName: data.params.callerName ?? null,
                        From: data.params.From,
                        To: data.params.To
                    })
                }
            });

            props.globalDialerSocket.on('call-ended', data => {


                if (data.room === 'callRoom:' + userId) {

                    if ((isCallInProgressRef.current &&
                        isCallInProgressRef.current.ignoreCallEnd && isCallInProgressRef.current.callStatus)
                        || !isCallInProgressRef.current.callStatus
                    ) {
                        if (props.isCallInProgress) {
                            return;
                        }
                    }
                    props.selectActiveContact({
                        contact_id: data.params.contact_id,
                        number: data.params.number,
                        first_name: data.params.first_name,
                        last_name: data.params.last_name,
                    });

                    if (data.params.contact_id) {
                        props._updateContactId(data.params.contact_id);
                        props.OpenContactDetailModal(true);
                    }

                    if (!callingTab) {


                        props.storeMultipleReducers({ isCallReceived: false, callStatus: 'Hanged Up', isCallInProgress: false, incomingCallConnection: null })
                        let tempResetDialerClearTimeout = setTimeout(() => {
                            props.resetDialer()
                        }, 2000)
                        setResetDialerClearTimeout(tempResetDialerClearTimeout)
                        setActiveCallConnection(null);
                        setCallingTab(false)

                        props.openDialog();

                    }

                }
            });

            props.globalDialerSocket.on('no-answer', data => {

                console.log('no answer');
                if (data.room === 'callRoom:' + userId) {
                    if (data.room === 'callRoom:' + userId) {
                        props.selectActiveContact({
                            contact_id: data.params.contact_id,
                            number: data.params.number,
                            first_name: data.params.first_name,
                            last_name: data.params.last_name,
                        });

                        if (data.params.contact_id) {
                            props._updateContactId(data.params.contact_id);

                            props.OpenContactDetailModal(true);
                        }
                        console.log('no answer disconnected');

                        props.storeMultipleReducers({
                            isCallReceived: false,
                            callStatus: 'Hanged Up',
                            isCallInProgress: false,
                            incomingCallConnection: null
                        })


                        let tempResetDialerClearTimeout = setTimeout(() => {
                            props.resetDialer()
                        }, 2000)
                        setResetDialerClearTimeout(tempResetDialerClearTimeout)
                        setActiveCallConnection(null);

                        setTimeout(() => {
                            props.openDialog();
                        }, 500)

                    }
                }
            });
        }

        if (props.currentCredit == null) {
            props.getCurrentCredit();
        }
        setWithExpiry('create_device_call_token_try', 1)
        setUpDevice();

        return (() => {
            resetDialerClearTimeout !== null ? clearTimeout(resetDialerClearTimeout) : console.log('unmount')
        }
        )

    }, [props.globalDialerSocket]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.updateNumber.dialerContactNumber !== null && props.updateNumber.contactInfo) {

            let activeContact = props.updateNumber.contactInfo;
            activeContact.contact_id = props.updateNumber.contactInfo.id;
            activeContact.firstName = props.updateNumber.contactInfo.first_name;
            activeContact.lastName = props.updateNumber.contactInfo.last_name;
            let tmpData = {
                contactSearchPageNo: 1, contactSearchLastPage: 1, activeContact: activeContact,
                recentContactLoading: false
                , dialNumber: activeContact.number
            }

            getDialerSettings()
                .then((res) => {
                    let response = res.data
                    if (response.status === 'success') {

                        if (response.data['dialer-selection'] === '2' && response.data['dialer-number'] && response.data['dialer-number'] !== '') {

                            let fromNumber = response.data['dialer-number'].trim();
                            if (fromNumber && fromNumber !== '') {

                                if (fromNumber[0] && fromNumber[0] === '+') {

                                } else {
                                    if (fromNumber.length === 11) {
                                        fromNumber = '+' + fromNumber
                                    } else if (fromNumber.length === 10) {
                                        fromNumber = '+1' + fromNumber

                                    }
                                }
                                tmpData = { ...tmpData, ...{ fixedDial: true, fixedDialNumber: fromNumber, fromNumber: fromNumber } }
                                props.storeMultipleReducers(tmpData)

                                initiateDial(activeContact, fromNumber)

                            } else {
                                props.storeMultipleReducers(tmpData)

                            }
                        }

                        else if (response.data['dialer-selection'] === '1') {
                            tmpData = { ...tmpData, ...{ fixedDial: false, fixedDialNumber: '' } }
                            props.storeMultipleReducers(tmpData)

                        }
                        else {
                            props.storeMultipleReducers(tmpData)

                        }
                    } else {
                        props.storeMultipleReducers(tmpData)

                    }
                })
                .catch((e) => {
                    props.storeMultipleReducers(tmpData)

                })
            // initiateDial(activeContact)


        }
        else if (props.updateNumber.dialerContactNumber !== null) {
            props.resetDialerWithNumber({ number: props.updateNumber.dialerContactNumber, updateInitialContact: !props.updateInitialContact })
        }

        // }

    }, [props.updateNumber]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setCallOnScreen(props.callOnScreen);
    }, [props.callOnScreen]);

    //Show the connection to the topbar
    useEffect(() => {
        if (activeCallConnection !== null) {
            let callerName = '';
            if (props.incomingCallConnection !== null) {
                callerName = activeCallConnection.CallerName ? activeCallConnection.CallerName : activeCallConnection.From;
            } else if (typeof props.activeContact.contact_id !== 'undefined') {
                callerName = props.activeContact.first_name + ' ' + props.activeContact.last_name
            } else {
                callerName = activeCallConnection.To;
            }
            try {
                props.setConnectedCalledInfo({
                    callerInfo: callerName, endCall: () => {
                        handleRejectCall();
                    }
                });
            } catch (e) {
                try {
                    sendErrorMessageToDevelopers({ subject: 'call end issue', body: `globaldialer 215 (userId : ${Utils.getAccountData('userId')}): ${e}` }).catch((err) => {
                        console.group("sendErrorMessageToDevelopers 256")
                        console.log(err)
                        console.groupEnd()
                    })

                } catch (e) {
                    console.log(e)
                }
            }

        } else {
            props.setConnectedCalledInfo(null);
        }
    }, [activeCallConnection]);// eslint-disable-line react-hooks/exhaustive-deps

    //To direct call
    useEffect(() => {
        if (props.dialOccurrence !== 0) {
            initiateDial();
        }
    }, [props.dialOccurrence])// eslint-disable-line react-hooks/exhaustive-deps

    window.updateVirtualNumberList = () => {
        props.getVirtualNumbers()
    }

    const setUpDevice = async () => {
        let local_storage_data = getWithExpiry('create_device_call_token_try')
        if (local_storage_data !== undefined && local_storage_data !== null) {
            if (parseInt(local_storage_data) >= 4) {
                if (Utils.getAccountData("centralBilling")) {
                    try {
                        let resp = await callEnvironment();
                        if (resp && resp.success && resp.status === "error") {
                            setCallEnvSetupAlertPopupData(resp.data);
                            setShowCallEnvSetupAlertPopup(true);
                        } else {
                            setCallEnvSetupAlertPopupData(null);
                            setShowCallEnvSetupAlertPopup(false);
                        }
                    } catch (err) {
                        console.log(err)
                    } finally {
                        // set flag in cookie for 5 minutes to track api
                        Utils.setPlainCookie("call-env-checked", "true", 5);
                    }
                }
                window.showNotification("ERROR", "Can not set up call environment. Please talk with our support team")
                return
            }
            else {
                setWithExpiry('create_device_call_token_try', (parseInt(local_storage_data) + 1))
            }
        }
        else {
            setWithExpiry('create_device_call_token_try', 1)
        }

        setMaximumTryToGetToken((prev) => { return prev + 1 });
        dialerTokenRequest(props.fromNumber).then(response => {
            //   console.log("332")
            // console.log(response)
            try {
                device = new Device(
                    response.data.token,
                    {
                        // sounds: {
                        //     incoming: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/incoming.mp3',
                        //     outgoing: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/outgoing.mp3',
                        //     disconnect: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/disconnect.mp3',
                        //     dtmf0: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-0.mp3',
                        //     dtmf1: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-1.mp3',
                        //     dtmf2: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-2.mp3',
                        //     dtmf3: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-3.mp3',
                        //     dtmf4: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-4.mp3',
                        //     dtmf5: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-5.mp3',
                        //     dtmf6: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-6.mp3',
                        //     dtmf7: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-7.mp3',
                        //     dtmf8: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-8.mp3',
                        //     dtmf8: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-9.mp3',
                        //     dtmfs: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-star.mp3',
                        //     dtmfh: 'https://d24gujj67p1uc1.cloudfront.net/asset/sounds/releases/1.0.0/dtmf-hash.mp3',
                        // },
                        closeProtection: true,
                        fakeLocalDTMF: true
                    }
                );
                // device.updateOptions({ closeProtection: true });

                device.register().catch((err) => {
                    console.group("register")
                    console.log(err)
                    console.groupEnd()
                });
            } catch (ex) {
                localStorage.setItem('device-call-register', false)
                console.log('Device setup error : ' + ex);
            }
            try {
                device.on("registered", () => {
                    setWithExpiry('create_device_call_token_try', 0)
                    setMaximumTryToGetToken(0)
                    localStorage.setItem('device-call-register', true)
                    console.log('Device is ready');

                })
                device.on('error', (twilioError, call) => {
                    Utils.handleException('An error has occurred: ', twilioError.originalError);

                });

                device.on('connect', (callInfo) => {
                    if (Utils.isEmpty(callInfo.callerName) || callInfo.callerName === 'null') {
                        callInfo.callerName = callInfo.To
                    }
                    let frmNum = callInfo.From;
                    if (frmNum) {
                        frmNum = "+" + frmNum.trim();

                    }
                    // console.log('connected ' + JSON.stringify(callInfo))
                    let tmpData = {
                        initialContactNumber: callInfo.To, fromNumber: frmNum,
                        isCallInProgress: true, callStatus: 'Received', updateInitialContact: !props.updateInitialContact,
                        callInfo: {
                            ...props.callInfo,
                            callSid: callInfo.callSid,
                            token: device.token,
                            callerName: callInfo.callerName,
                            callerNumber: callInfo.To
                        }
                    }
                    // console.log(tmpData)
                    props.storeMultipleReducers(tmpData)
                    setActiveCallConnection(callInfo);

                });

                device.on('incoming', call => {

                    Utils.isMicrophoneOn().then((isOn) => {
                        if (isOn) {
                            console.log('Microphone is active.');
                        }
                    });

                    if (isCallInProgressRef.current.callStatus && (!isCallInProgressRef.current.callSid || isCallInProgressRef.current.callSid !== call.parameters.CallSid)) {

                        console.log('Disconnecting incoming call as another call is in progress');
                        if (call.parameters && call.parameters.CallSid) {

                            isCallInProgressRef.current = { ...isCallInProgressRef.current, ignoreCallEnd: true }

                            callCancelByCallSid({ callSid: call.parameters.CallSid })
                        }
                        return; // Exit early
                    } else {

                        call.on('accept', call => {
                            console.log('call accept: ', call);
                            callEvent = call;
                            props.storeMultipleReducers({ callStatus: 'Received' });
                            setActiveCallConnection({ ...tmpCallInfo, From: call.parameters.From })
                        });
                        call.on('cancel', callInfo => {


                            if (call && call.parameters && call.parameters.CallSid) {
                                callCancelByCallSid({ callSid: call.parameters.CallSid }).then(res => {

                                    if (res.data && res.data.status === true) {
                                        props.storeMultipleReducers({
                                            isCallReceived: false,
                                            callStatus: 'Hanged Up',
                                            isCallInProgress: false,
                                            incomingCallConnection: null
                                        });

                                        let tempResetDialerClearTimeout = setTimeout(() => {
                                            props.resetDialer();
                                        }, 2000);
                                        setResetDialerClearTimeout(tempResetDialerClearTimeout);
                                        props.closeDialog();
                                    }

                                })
                            }
                        });
                        call.on('disconnect', callInfo => {

                            props.storeMultipleReducers({
                                isCallReceived: false,
                                callStatus: 'Hanged Up',
                                isCallInProgress: false,
                                incomingCallConnection: null
                            });

                            let tempResetDialerClearTimeout = setTimeout(() => {
                                props.resetDialer()
                            }, 2000)
                            setResetDialerClearTimeout(tempResetDialerClearTimeout)
                            props.closeDialog();
                        });

                        call.on('reject', callInfo => {

                            props.storeMultipleReducers({
                                isCallReceived: false,
                                callStatus: 'Hanged Up',
                                isCallInProgress: false,
                                incomingCallConnection: null
                            });

                            let tempResetDialerClearTimeout = setTimeout(() => {
                                props.resetDialer()
                            }, 2000)
                            setResetDialerClearTimeout(tempResetDialerClearTimeout)
                            props.closeDialog();
                        });

                        let tmpCallInfo = {
                            ...props.callInfo,
                            callSid: call.parameters.CallSid,
                            callerName: call.customParameters.CallerName,
                            callerNumber: call.parameters.From,
                            callerInfo: call.parameters.From
                        }
                        if (call.customParameters.get('CallerName')) {
                            tmpCallInfo['callerName'] = call.customParameters.get('CallerName')
                        }
                        props.storeMultipleReducers({
                            isCallReceived: true, callStatus: 'Incoming', isCallInProgress: true, goToNextInList: false,
                            callInfo: tmpCallInfo, incomingCallConnection: call, enableWarmTransfer: false
                        });
                        // console.log('400 '+ JSON.stringify(tmpCallInfo))
                        props.openDialog();
                    }

                });

                device.on('unregistered', () => {
                    console.log('unregister')
                    try {
                        if (maximumTryToGetToken < 5) {
                            setUpDevice();
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            } catch (e) {
                console.log(`globaldialer 275 : ${e}`);
                try {
                    sendErrorMessageToDevelopers({ subject: 'dialer issue', body: `globaldialer 301 (userId : ${Utils.getAccountData('userId')}) : ${e}` }).catch((err) => {
                        // console.group("sendErrorMessageToDevelopers 365")
                        // console.log(err)
                        // console.groupEnd()
                    })

                } catch (e) {
                    console.log(e)
                }

            }

        }).catch((reason) => {
            console.group(" token ")
            console.log(reason)
            console.groupEnd()
        });
    }

    const callEvents = () => {

        callEvent.on('cancel', callInfo => {
            props.storeMultipleReducers({
                isCallReceived: false,
                callStatus: 'Hanged Up',
                isCallInProgress: false,
                incomingCallConnection: null
            })

            let tempResetDialerClearTimeout = setTimeout(() => {
                props.resetDialer()
            }, 2000)
            setResetDialerClearTimeout(tempResetDialerClearTimeout)
            props.openDialog();
            setCallingTab(false)


        });

        callEvent.on('reject', callInfo => {
            props.storeMultipleReducers({
                isCallReceived: false,
                callStatus: 'Hanged Up',
                isCallInProgress: false,
                incomingCallConnection: null
            })

            let tempResetDialerClearTimeout = setTimeout(() => {
                props.resetDialer()
            }, 2000)
            setResetDialerClearTimeout(tempResetDialerClearTimeout)
            props.openDialog();
            setCallingTab(false)


        });

        callEvent.on('disconnect', call => {

            // let timeDiv = document.getElementById('running_timer');
            // if (timeDiv) {
            //     props.storeMultipleReducers({isCallReceived : false,callStatus: 'Hanged Up',isCallInProgress: false, callTime: timeDiv.innerHTML})

            // }else{
            props.storeMultipleReducers({ isCallReceived: false, callStatus: 'Hanged Up', isCallInProgress: false })

            let tempResetDialerClearTimeout = setTimeout(() => {
                props.resetDialer()
            }, 2000)
            setResetDialerClearTimeout(tempResetDialerClearTimeout)
            props.storeMultipleReducers({ incomingCallConnection: null })
            // }
            setActiveCallConnection(null);
            setCallingTab(false)
            if (localStorage.getItem('isDialFromMap') === "true") {
                props.closeDialog();
            }


        });

        callEvent.on('cancel', () => {
            props.storeMultipleReducers({
                isCallReceived: false,
                callStatus: 'Hanged Up',
                isCallInProgress: false,
                incomingCallConnection: null
            })

            setTimeout(() => {
                props.resetDialer()
            }, 2000)
            props.openDialog();
            setCallingTab(false)

        });
    }

    const initiateDial = async (contact = null, fromNum = null) => {

        // setUpDevice()
        // console.log('globaldialer 516: contact :' + contact)

        Utils.isMicrophoneOn().then((isOn) => {
            if (isOn) {
                console.log('Microphone is active.');
            } else {
                return;
            }
        });

        if (!callingTab) {
            let toNumber;
            let callerName;
            setCallingTab(true)

            if (contact) {
                toNumber = contact.number
                Helper.getContactName(contact)
                callerName = Helper.getContactName(contact)

            } else {
                toNumber = props.stage === 'contact' ? props.activeContact.number : props.dialNumber;
                callerName = Helper.getContactName(props.activeContact)
            }
            props.storeMultipleReducers({ isCallInProgress: true, enableWarmTransfer: false })

            if (toNumber) {

                toNumber = toNumber.replace(/\D/g, '')
                if (toNumber.length > 9) {
                    if (toNumber.length === 12 && toNumber[0] !== '+') {

                        if (userId == 91 || userId == 14994) {
                            toNumber = '+' + toNumber
                        } else {
                            window.showNotification('ERROR', 'invalid number');
                            setCallingTab(false)

                            return;
                        }

                    }
                    else if (toNumber.length === 12 && toNumber[0] === '+' && toNumber[1] !== '1') {
                        window.showNotification('ERROR', 'invalid number');
                        setCallingTab(false)
                        return;
                    } else if (toNumber.length === 13 && toNumber[0] === '+' && userId == 97) {
                        // number is ok. affan call to uae
                    }
                    else {

                        if (toNumber.length === 11 && (userId == 91 || userId == 14994) && toNumber[0] === '9' && toNumber[1] === '7' && toNumber[2] === '1') {
                            toNumber = '+' + toNumber

                        }
                        else if (toNumber.length === 11 && toNumber[0] !== '1') {


                            window.showNotification('ERROR', 'invalid number');
                            setCallingTab(false)
                            return;
                        } else if (toNumber.length === 10) {
                            toNumber = '+1' + toNumber
                        }
                    }
                } else {
                    window.showNotification('ERROR', 'invalid number');
                    setCallingTab(false)
                    props.storeMultipleReducers({ isCallInProgress: false })
                    return;
                }
            } else {
                window.showNotification('ERROR', 'invalid number');
                props.storeMultipleReducers({ isCallInProgress: false })
                setCallingTab(false)
                return;
            }


            let fromNumbers = fromNum ?? props.fromNumber
            let fromNumber = '';
            if (fromNumbers && fromNumbers !== '') {

                let from = fromNumbers.trim()
                if (from[0] && from[0] === '+') {

                    fromNumber = from
                } else {
                    if (from.length === 11) {
                        fromNumber = '+' + from
                    } else if (from.length === 10) {
                        fromNumber = '+1' + from

                    }
                }

            }

            if (fromNumber !== '') {
                let params = {
                    To: toNumber,
                    From: fromNumber,
                    fromNumber: fromNumber,
                    TimeLimit: 7200,
                    isConferenceCall: true,
                    ContactId: contact ? contact.id : props.stage === 'contact' ? props.activeContact.id : undefined,
                    callerName: callerName,
                    dialFromMap: localStorage.getItem('isDialFromMap') === "true",
                    powerDial: false,
                    userId: userId,
                    parentId: Utils.getAccountData('parentId'),
                    agencyId: Utils.getAccountData('agencyId'),
                    teamId: Utils.getAccountData('teamId')
                };
                props.storeMultipleReducers({ dialNumber: toNumber });

                // console.log(params);
                if (!localStorage.getItem('device-call-register')) {

                    try {
                        setCallingTab(false)
                        props.storeMultipleReducers({ isCallInProgress: false })
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                    try {
                        await device.disconnectAll();

                    } catch (e) {
                        setCallingTab(false)
                        props.storeMultipleReducers({ isCallInProgress: false })

                        // console.log('globaldialer361 : '+e)
                    }
                    try {
                        callEvent = await device.connect({ params: params });
                        props.storeMultipleReducers({ 'isCallReceived': false })
                        callEvents();

                    } catch (e) {
                        setCallingTab(false)
                        props.storeMultipleReducers({ isCallInProgress: false })

                        console.log('globaldialer366 : ' + e)
                    }
                }
            } else {
                props.storeMultipleReducers({ isCallInProgress: false })
                setCallingTab(false)
                if (window.showNotification) {
                    window.showNotification('SUCCESS', 'Please Reload Page and try again!')

                }
            }

        }

    }

    const handleAcceptCall = () => {
        if (props.incomingCallConnection !== null) {
            props.incomingCallConnection.accept();
        }
    }

    const handleRejectCall = (instant = false) => {

        console.log('handle reject call : function calls');
        if (props.incomingCallConnection !== null) {

            if (props.incomingCallConnection.parameters && props.incomingCallConnection.parameters.CallSid) {
                callCompleteByCallSid({ callSid: props.incomingCallConnection.parameters.CallSid }).then(res => {
                    console.log('call complete')
                })
            }
            if (!instant) {
                props.storeMultipleReducers({
                    isCallReceived: false,
                    callStatus: 'Hanged Up',
                    isCallInProgress: false,
                    incomingCallConnection: null
                })

                let tempResetDialerClearTimeout = setTimeout(() => {
                    props.resetDialer()
                }, 2000)
                setResetDialerClearTimeout(tempResetDialerClearTimeout)
            }

            device.disconnectAll();
        } else {
            console.log('782');

            callHangUp({ participant: 'all', conferenceSid: props.callInfo.conferenceSid, isSecondCallInProgress: props.isSecondCallInProgress, callSid: props.callInfo.firstCallSid }).then(response => {
                if (response.data.status) {
                    if (!instant && callingTab)
                        console.log('Participant removed.');
                }
            }).catch((err) => {
                console.log(err)
            })
        }
    }

    const sendDigit = digit => {
        callEvent.sendDigits(digit);
    }

    const muteMyself = shouldMute => {
        callEvent.mute(shouldMute);
    }

    return (
        <div className="global__dialer">
            {(props.isCallInProgress && props.enableWarmTransfer !== true) ?
                <CallingState
                    acceptCall={() => handleAcceptCall()}
                    rejectCall={() => handleRejectCall()}
                    sendDigit={sendDigit}
                    muteMyself={muteMyself}
                />

                :
                <>
                    {props.stage === 'dial' ?
                        <NumberPad initiateDial={initiateDial} />
                        :
                        <RecentContacts />
                    }
                    <FromNumber />
                    <DialTrigger initiateDial={initiateDial} />
                </>
            }


            {!props.enableWarmTransfer && (props.isCallInProgress !== true) &&
                <div className="options-icon-list">
                    <Stage />
                </div>
            }

            {props.enableWarmTransfer &&
                <>
                    <SecondCall muteMyself={muteMyself} />

                    <div className="call__screen__control">
                        <button className={"first__call__active " + (callOnScreen === 'first' ? 'active' : '')} onClick={() => props.toggleScreen('first')}>
                            <i data-v-adbe2af4="">
                                <svg data-v-adbe2af4="" width="18" height="18" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><g data-v-adbe2af4="" opacity="0.55"><path data-v-adbe2af4="" d="M21.2292 16.695L18.6018 14.2059C18.0256 13.6297 17.4725 13.5375 17.0807 13.5375C16.3432 13.5606 15.8592 13.9985 15.7209 14.1367L14.3842 15.4274C13.0474 14.759 11.8259 13.9063 10.6966 12.8231L10.5814 12.7309C9.42902 11.6476 8.53018 10.4722 7.81572 9.15856L9.03722 7.77573C9.17551 7.63744 9.59035 7.13041 9.56731 6.3929C9.56731 6.02414 9.42902 5.44797 8.8298 4.91788L6.20242 2.3827C6.04109 2.19832 5.51101 1.71433 4.72741 1.66823C4.31256 1.64519 3.66724 1.76042 3.04496 2.35965C2.92973 2.47488 1.89261 3.44286 1.50081 4.64132C1.22424 5.30968 -0.826957 10.9793 6.01805 17.4555L6.15633 17.5938C10.0052 21.2814 13.4392 22.1571 15.8361 22.1571C17.6799 22.1571 18.9014 21.6501 19.178 21.5118C20.3534 21.0509 21.2753 19.9677 21.3674 19.8755C21.9436 19.2071 22.0358 18.5618 21.9897 18.1469C21.9206 17.3403 21.4135 16.8563 21.2292 16.695ZM19.9846 18.677C19.7772 18.9075 19.1319 19.5759 18.5096 19.8063L18.4174 19.8524C18.3483 19.8524 13.6006 22.1802 7.44697 16.2571L7.30869 16.1188C1.1551 10.3109 3.11411 5.54015 3.20629 5.35578L3.25239 5.26359C3.45981 4.61827 4.08209 3.9499 4.31256 3.71943C4.42779 3.60419 4.56608 3.53505 4.63522 3.53505C4.72741 3.53505 4.81959 3.62724 4.84264 3.65029L7.58525 6.27766C7.70049 6.36985 7.72354 6.43899 7.72354 6.46204C7.72354 6.48509 7.70049 6.50813 7.67744 6.55423L5.62625 8.90504L5.90281 9.45817C6.73251 11.1867 7.86182 12.7078 9.31379 14.0906L9.42902 14.1828C10.881 15.5657 12.4712 16.6258 14.2228 17.3633L14.776 17.5938L17.0115 15.4504L17.0346 15.4043C17.0576 15.3813 17.1037 15.3582 17.1037 15.3582C17.1268 15.3582 17.1959 15.3813 17.3111 15.4965L19.9846 18.0317L20.0538 18.0778C20.0999 18.1008 20.169 18.2161 20.192 18.3083C20.169 18.4005 20.0999 18.5157 19.9846 18.677Z" fill="#27AE60" stroke="#27AE60" strokeWidth="0.35"></path><path data-v-adbe2af4="" d="M11.8032 1C11.2962 1 10.8813 1.41485 10.8813 1.92189V7.4532C10.8813 7.96024 11.2962 8.37509 11.8032 8.37509C12.3103 8.37509 12.7251 7.96024 12.7251 7.4532V1.92189C12.7251 1.41485 12.3103 1 11.8032 1Z" fill="#27AE60" stroke="#27AE60" strokeWidth="0.35"></path><path data-v-adbe2af4="" d="M21.0448 10.4263H15.283C14.7759 10.4263 14.3611 10.8411 14.3611 11.3482C14.3611 11.8552 14.7759 12.27 15.283 12.27H21.0448C21.5518 12.27 21.9666 11.8552 21.9666 11.3482C21.9666 10.8411 21.5518 10.4263 21.0448 10.4263Z" fill="#27AE60" stroke="#27AE60" strokeWidth="0.35"></path><path data-v-adbe2af4="" d="M19.7312 5.24068C20.123 4.89497 20.146 4.31879 19.8233 3.95004C19.4776 3.55824 18.9015 3.53519 18.5327 3.85785L13.9002 7.86805C13.5084 8.21376 13.4854 8.78994 13.808 9.15869C13.9924 9.36612 14.2459 9.48135 14.4995 9.48135C14.7069 9.48135 14.9374 9.41221 15.0987 9.25088L19.7312 5.24068Z" fill="#27AE60" stroke="#27AE60" strokeWidth="0.35"></path></g></svg>
                            </i>
                        </button>
                        <button className={"second__call__active " + (callOnScreen === 'second' ? 'active' : '')} onClick={() => props.toggleScreen('second')}>
                            <i data-v-adbe2af4="">
                                <svg data-v-adbe2af4="" width="18" height="18" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-adbe2af4="" d="M11.9705 14.164H13.4158V15.6093C13.4158 16.2479 13.9335 16.7656 14.572 16.7656C15.2105 16.7656 15.7282 16.2479 15.7282 15.6093V14.164H17.1736C17.8121 14.164 18.3298 13.6463 18.3298 13.0078C18.3298 12.3693 17.8121 11.8515 17.1736 11.8515H15.7282V10.4062C15.7282 9.76771 15.2105 9.25 14.572 9.25C13.9335 9.25 13.4158 9.76771 13.4158 10.4062V11.8515H11.9705C11.3319 11.8515 10.8142 12.3693 10.8142 13.0078C10.8142 13.6463 11.3319 14.164 11.9705 14.164Z" fill="#FF9416"></path><path data-v-adbe2af4="" d="M25.8446 4.91404H22.0868V1.15624C22.0868 0.517708 21.569 0 20.9305 0C20.292 0 19.7743 0.517708 19.7743 1.15624V4.91404H16.0165C15.3779 4.91404 14.8602 5.43175 14.8602 6.07028C14.8602 6.70882 15.3779 7.22653 16.0165 7.22653H19.7743V10.9843C19.7743 11.6229 20.292 12.1406 20.9305 12.1406C21.569 12.1406 22.0868 11.6229 22.0868 10.9843V7.22653H25.8446C26.4831 7.22653 27.0008 6.70882 27.0008 6.07028C27.0008 5.43175 26.4831 4.91404 25.8446 4.91404Z" fill="#FF9416"></path><path data-v-adbe2af4="" d="M17.9989 18.8253C17.3728 18.1194 16.7005 17.9711 16.2466 17.9711C15.4734 17.9711 14.9288 18.3951 14.7626 18.5429L13.4289 19.6797C12.1662 18.9605 11.0317 18.0517 9.97689 16.9169L9.87312 16.8053C8.81863 15.6705 7.99538 14.4729 7.37072 13.1614L8.60096 11.915C8.76717 11.7534 9.25916 11.2088 9.28459 10.3882C9.29789 9.95745 9.18227 9.30938 8.57524 8.68645L6.04191 5.95627C5.69359 5.52788 5.01863 5.05469 4.18584 5.05469C3.5924 5.05469 3.02324 5.28131 2.51189 5.71375C2.37979 5.8207 1.22326 6.78501 0.722893 8.03809C0.370239 8.77172 -2.06712 14.5417 4.60441 21.6699L4.73997 21.8182C8.81978 26.2382 12.6559 27.1713 15.1554 27.1713C15.1557 27.1713 15.1557 27.1713 15.156 27.1713C16.7213 27.1713 17.7639 26.8031 18.055 26.6877C19.3407 26.2802 20.3854 25.193 20.4863 25.0855C21.18 24.3764 21.304 23.6668 21.2858 23.1964C21.2517 22.3191 20.7262 21.7315 20.5218 21.5349L17.9989 18.8253ZM18.8181 23.4855C18.664 23.6491 17.9605 24.3004 17.3338 24.488C17.2962 24.4992 17.2494 24.5189 17.213 24.5339C17.2054 24.5374 16.4258 24.8588 15.156 24.8588C15.156 24.8588 15.1557 24.8588 15.1554 24.8588C13.1175 24.8588 9.95146 24.055 6.43676 20.2474L6.2957 20.0908C0.480371 13.8771 2.71221 9.22757 2.80529 9.04171C2.82668 9.00066 2.84576 8.95875 2.86223 8.91539C3.08828 8.32137 3.73982 7.69671 3.98639 7.49378C4.10491 7.39348 4.17342 7.37093 4.17428 7.36602C4.19278 7.37325 4.2266 7.39753 4.25002 7.42036C4.27517 7.45823 4.27488 7.451 4.31563 7.49523L6.89926 10.2795C6.9114 10.2922 6.9221 10.3037 6.93135 10.3142L5.17154 12.0974C4.84548 12.4278 4.74865 12.9209 4.92526 13.3499C5.68578 15.1967 6.75011 16.842 8.1798 18.3801L8.28358 18.4917C9.71183 20.0286 11.2751 21.2103 13.062 22.1044C13.4774 22.3125 13.9763 22.2515 14.3293 21.9506L16.2359 20.3258C16.2504 20.3402 16.2677 20.3582 16.2874 20.3807L18.8566 23.1404C18.8976 23.1843 18.8904 23.1834 18.9268 23.2118C18.9488 23.2378 18.9719 23.2733 18.9759 23.2733C18.9759 23.2739 18.9572 23.3433 18.8181 23.4855Z" fill="#FF9416"></path></svg>
                            </i>
                        </button>
                    </div>
                </>
            }
            {
                showCallEnvSetupAlertPopup &&
                callEnvSetupAlertPopupData &&
                <CallEnvironmentSetupAlertPop
                    open={showCallEnvSetupAlertPopup}
                    onClose={() => { setShowCallEnvSetupAlertPopup(false); }}
                    data={callEnvSetupAlertPopupData}
                />
            }
        </div>
    );
}

const mapStateToProps = state => {
    return {
        currentCredit: state.globalDialerReducer.currentCredit,
        stage: state.globalDialerReducer.stage,
        activeContact: state.globalDialerReducer.activeContact,
        dialNumber: state.globalDialerReducer.dialNumber,
        isCallInProgress: state.globalDialerReducer.isCallInProgress,
        enableWarmTransfer: state.globalDialerReducer.enableWarmTransfer,
        fromNumber: state.globalDialerReducer.fromNumber,
        secondCallStage: state.globalDialerReducer.secondCallStage,
        callOnScreen: state.globalDialerReducer.callOnScreen,
        callInfo: state.globalDialerReducer.callInfo,
        callStatus: state.globalDialerReducer.callStatus,
        isSecondCallInProgress: state.globalDialerReducer.isSecondCallInProgress,
        updateInitialContact: state.globalDialerReducer.updateInitialContact,
        globalDialerSocket: state.globalDialerReducer.globalDialerSocket,
        incomingCallConnection: state.globalDialerReducer.incomingCallConnection
    };
};
const mapDispatchToProps = dispatch => {
    return {
        getCurrentCredit: () => dispatch(getCurrentCredit()),
        toggleScreen: (params) => dispatch(toggleScreen(params)),
        updateSecondCallStatus: (params) => dispatch(updateSecondCallStatus(params)),
        selectActiveContact: (params) => dispatch(selectActiveContact(params)),
        _updateContactId: (params) => dispatch(_updateContactId(params)),
        resetDialerWithNumber: (params) => dispatch(resetDialerWithNumber(params)),
        resetDialer: (params) => dispatch(resetDialer(params)),
        storeMultipleReducers: (params) => dispatch(storeMultipleReducers(params)),
        getVirtualNumbers: () => dispatch(getVirtualNumbers()),

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(GlobalDialer));

function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
    }
    return item.value
}
function setWithExpiry(key, value, ttl = 3600000) {
    const now = new Date()
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
}